import { findPos } from './index'

export function flashNewItem({ itemId, classToAdd, autoscroll }) {
  // Scroll to and flash the item node
  let _el = document.getElementById(
    typeof itemId === 'string' ? itemId : JSON.stringify(itemId)
  )
  if (autoscroll) {
    window.scroll(0, findPos(_el))
  }
  _el.className += ' flash'
  if (classToAdd) {
    setTimeout(() => {
      _el.className = classToAdd
    }, 500)
  }

  // remove the flash class
  setTimeout(() => {
    _el.className = _el.className.replace(' flash', '')
  }, 500)
}



// WEBPACK FOOTER //
// ./src/utils/animation.js